import React, { memo } from 'react'
import { useSiteUrl } from '../../../context/site-url'

import { ButtonWrapper, IconImage, UserIconWrapper } from './header-section-styles'
import ExternalLink from './../../common/external-link'
import { HeaderSectionTransport } from './../../../transports/region-landing-page-transport'
import UserCheckIcon from '../../../assets/icons/userbar-icons/user-check.svg'
import UserHeaderIcon from '../../../assets/icons/userbar-icons/user-logo.svg'
import type { StyledSvgComponent } from '../../../types/svg'

type Navigation = HeaderSectionTransport['navigationSectionResponse']['navigation']

interface UserMenuMobileProps {
    navigation: Navigation
    isLoggedIn: boolean
    toggleUserSidebar: () => void
}

const UserMenuMobile: React.FC<UserMenuMobileProps> = ({ navigation, isLoggedIn, toggleUserSidebar }) => {
    const { originalUrl } = useSiteUrl()
    const { loginButton } = navigation

    if (isLoggedIn) {
        return (
            <ButtonWrapper onClick={toggleUserSidebar}>
                <IconImage as={UserCheckIcon as StyledSvgComponent} />
            </ButtonWrapper>
        )
    }

    return (
        <ExternalLink href={`${loginButton.url}?target=${originalUrl}`} as={UserIconWrapper} noCrawl>
            <IconImage as={UserHeaderIcon as StyledSvgComponent} />
        </ExternalLink>
    )
}

export default memo(UserMenuMobile)
